import { produce } from 'immer';

import { ClearInternalBanner } from '../../../actions/bannersEdit/internal/clearInternalBanner';
import {
    createInternalEditedBanner,
    generateNewTemplateVars
} from '../../../service/InternalBannerHelpers/InternalBannerHelpers';
import { EditInternalBannersState } from '../../../typings/internalBannersEditState';

export function clearInternalBanner(
    state: EditInternalBannersState,
    action: ClearInternalBanner
): EditInternalBannersState {
    return produce(state, draft => {
        const bannerId = action.bannerId;
        const banner = draft.banners[bannerId];
        const group = draft.groupBannersList[banner.group.id];

        draft.banners[bannerId] = createInternalEditedBanner({
            id: banner.id,
            isNew: banner.isNew,
            group: {
                id: group.groupId,
                name: group.groupName,
                status: group.status,
                canEdit: group.canEdit,
                type: group.type
            },
            campaign: group.campaign,
            canBeDeleted: banner.canBeDeleted
        });

        if (!banner.isNew) {
            // Менять идентификатор сохранённого шаблона нельзя, поэтому его сохраняем неизменным
            draft.banners[bannerId].templateId = banner.templateId;
            // Генерируем новые пустые templateVars для используемого шаблона
            draft.banners[bannerId].templateVars = generateNewTemplateVars(
                draft,
                banner.campaign.id,
                banner.templateId
            );
        }

        draft.bannersDraft[bannerId] = {};
    });
}
